<template>
  <v-dialog
    :value="value"
    max-width="650"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card>
      <!-- Header -->
      <v-card-title class="headline">
        <v-icon left color="primary">mdi-clipboard-list</v-icon>
        {{ $t('cost-center.cost-centers') }}
      </v-card-title>

      <v-divider></v-divider>

      <!-- Content -->
      <v-card-text class="pa-4">
        <cost-center-allocation-editor
          v-model="localAllocations"
          :cost-centers="costCenters"
          :organization-id="organizationId"
          :show-chart="true"
          chart-type="stacked"
          @validation="onValidation"
        />
      </v-card-text>

      <v-divider></v-divider>

      <!-- Actions -->
      <v-card-actions class="px-4 py-3">
        <v-spacer></v-spacer>
        <v-btn
          text
          small
          @click="cancel"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          small
          :disabled="!isValid"
          @click="save"
        >
          <v-icon small left>mdi-check</v-icon>
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CostCenterAllocationEditor from './CostCenterAllocationEditor.vue'

export default {
  name: 'CostCenterAllocationModal',

  components: {
    CostCenterAllocationEditor
  },

  props: {
    // v-model: dialog visibility
    value: {
      type: Boolean,
      default: false
    },
    // Current allocations
    allocations: {
      type: Array,
      default: () => []
    },
    // Pre-loaded cost centers
    costCenters: {
      type: Array,
      required: true
    },
    // Organization ID
    organizationId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      localAllocations: [],
      validation: { valid: false, errors: [] }
    }
  },

  computed: {
    isValid() {
      return this.localAllocations.length === 0 || this.validation.valid
    }
  },

  watch: {
    value(isOpen) {
      if (isOpen) {
        // Reset local allocations when opening
        this.localAllocations = this.allocations ? JSON.parse(JSON.stringify(this.allocations)) : []
      }
    }
  },

  methods: {
    onValidation(validation) {
      this.validation = validation
    },

    cancel() {
      this.$emit('input', false)
    },

    save() {
      if (this.isValid) {
        // Filter out soft-deleted allocations and keep only active ones
        const activeCostCenters = this.localAllocations
          .filter(alloc => !alloc.isDeleted)
          .map(alloc => ({
            costCenterId: alloc.costCenterId,
            costCenterName: alloc.costCenterName,
            sharePercent: alloc.sharePercent
          }))

        this.$emit('save', activeCostCenters)
      }
    }
  }
}
</script>
